module.exports = __webpack_public_path__ + "media/images/newsletters__icon__unselected-6f46950a98aa0232455f6fb6c7c496c0.svg";